import DashboardPage from "../UserPages/DashboardPage";

export const RouterItems = [
  {
    link: "/dashboard",
    name: "Dashboard",
    page: <DashboardPage />,
  }
];
